export default __webpack_public_path__ + "images/loggedout/home/modularPage/modular_section3-7b2670fe8069572c5d647a4a42923a79.png";